import * as React from 'react';
import style from '../GuideLink.scss';
import ExternalLinkIcon from 'wix-ui-icons-common/ExternalLink';
import { Box } from 'wix-style-react';
import { ExternalLink } from '../../../PageElements/ExternalLink';
import classnames from 'classnames';

export const ExternalMenuLink = ({ url, title, isTopLevel }) => (
  <ExternalLink
    to={url}
    className={classnames({
      [style.guideLink]: true,
      [style.topLevel]: isTopLevel,
    })}
    size="small"
    weight="normal"
    link={false}
    menuLink
    secondary
  >
    <Box>
      <ExternalLinkIcon size="18px" />
      {title}
    </Box>
  </ExternalLink>
);
